export default "__VITE_ASSET__Dq7kbjno__"